/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = {
  header: 'header',
  placeholder: 'placeholder',
  cancel: 'cancel',
  send: 'send',
  success: 'success',
  warning: 'warning',
  error: 'error'
}; export default Keys;